// extracted by mini-css-extract-plugin
module.exports = {"firstKv":"FirstKv_firstKv__QkWOY"};